import { css } from 'styled-components';

/**
 * The section tree's card surface and pill-shaped rows.
 *
 * Deliberately the same visual language as `ui-builder/utils/sideTabsStyles` —
 * the look the IDMP screen uses — so the two screens read as one product. It is
 * a separate block rather than a reuse because that one is scoped to antd's
 * side *tabs*, and this is a `Menu`: nested to five levels, with a row action
 * on each item, which a tab set cannot express. Same tokens and the same
 * fallbacks, so they stay in step; if they ever diverge, `sideTabsStyles` is
 * the reference.
 */
export const menuSurfaceStyles = css`
  border-radius: 0 0 12px 12px;
  padding: 10px;

  /* On the root, and forced: antd v5 generates its own class combinations for
     the menu background, which outrank a bare declaration here. */
  &.ant-menu {
    background: ${({ theme }) =>
      theme?.colors?.surface || '#ffffff'} !important;
  }

  /* Nested submenus stay clear so the card reads as one surface. */
  .ant-menu-sub.ant-menu-inline {
    background: transparent !important;
  }

  /* antd draws a right border on inline menus; the card edge replaces it. */
  &.ant-menu-inline {
    border-inline-end: none !important;
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    height: auto !important;
    margin: 0 !important;
    padding-top: 7px !important;
    padding-bottom: 7px !important;
    border-radius: 8px !important;
    line-height: 1.45 !important;
    color: ${({ theme }) => theme?.colors?.textSecondary || '#64748b'};
    transition: background 0.15s ease;
  }

  /* Rows can now be two lines — a repeatable block's nature/type sits under
     its title. Truncation belongs to the row's own spans, so antd's clip here
     can only cut the second line off. */
  .ant-menu-title-content {
    overflow: visible !important;
  }

  .ant-menu-item + .ant-menu-item,
  .ant-menu-item + .ant-menu-submenu,
  .ant-menu-submenu + .ant-menu-item,
  .ant-menu-submenu + .ant-menu-submenu {
    margin-top: 2px !important;
  }

  .ant-menu-item:hover,
  .ant-menu-submenu-title:hover {
    background: ${({ theme }) => theme?.colors?.primaryLighter || '#f4f5ff'};
  }

  .ant-menu-item-selected {
    background: ${({ theme }) =>
      theme?.colors?.primaryLight || '#e8e9ff'} !important;
    color: ${({ theme }) => theme?.colors?.primary || '#5c67f7'} !important;
  }

  /* antd's selected-item underline duplicates the pill. */
  .ant-menu-item-selected::after {
    display: none !important;
  }
`;
